import { render } from "./Prelude.vue?vue&type=template&id=39486591&scoped=true"
import script from "./Prelude.vue?vue&type=script&lang=js"
export * from "./Prelude.vue?vue&type=script&lang=js"

import "./Prelude.vue?vue&type=style&index=0&id=39486591&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39486591"

export default script